/**
 * 결제 실패 컴포넌트
 * FSD: features/subscription/payment-result/ui
 */

import React from 'react';

interface PaymentErrorProps {
  message: string;
}

export const PaymentError: React.FC<PaymentErrorProps> = ({ message }) => {
  return (
    <div className="payment-error">
      <div className="error-icon">✗</div>
      <h2>결제 실패</h2>
      <p className="message">{message}</p>
      <p className="redirect-notice">잠시 후 이전 페이지로 돌아갑니다...</p>
    </div>
  );
};
